import { useState } from "react";
import { Link } from "react-router-dom";
import { adminAPI } from "@/services/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const AdminRequestPasswordRecovery = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (event) => {
    event.preventDefault();
    try { await adminAPI.requestPasswordRecovery(email); } finally { setSent(true); setEmail(""); }
  };
  return <main className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
    <section className="w-full max-w-md rounded-2xl border bg-white p-6 shadow-sm">
      <h1 className="text-2xl font-semibold">Recover admin access</h1>
      {sent ? <div className="mt-4 space-y-4"><p className="text-sm text-gray-600">If an active staff account exists for that address, recovery instructions will be sent.</p><Button asChild className="w-full"><Link to="/admin/login">Back to sign in</Link></Button></div> : <form className="mt-6 space-y-4" onSubmit={submit}><div><Label htmlFor="recovery-email">Staff email</Label><Input id="recovery-email" type="email" autoComplete="email" required value={email} onChange={(event) => setEmail(event.target.value)} /></div><Button className="w-full" type="submit">Send recovery instructions</Button></form>}
    </section>
  </main>;
};

export default AdminRequestPasswordRecovery;
